<template>
  <div class="carriage-form">
    <!--    <div class="passing-module-title">车节详情</div>-->
    <row-edit-form
      popover-edit
      :column="formColumn"
      :col-span="[8, 16]"
      :data-list="formData"
      :custom-params="{trainSerial: carriageInfo.trainSerial}"
      :edit-config="{ url: '/check/train/detailList/update', params: formData }"
      :label-style="{backgroundColor: '#E1F2FF'}"
      @handleUpdate="updateCarriage"
    >
    </row-edit-form>
  </div>
</template>

<script>
import RowEditForm from "@/components/matrix/row-edit-form.vue";
import RowEditor from "@/components/matrix/row-editor.vue";

export default {
  name: "carriage-form",
  components: {RowEditor, RowEditForm},
  props: {
    carriageInfo: Object
  },
  data() {
    return {
      formData: {},
      formColumn: [
        {
          label: '车型', field: 'trainType', maxlength: 8,
          validate: str => this.validateStr(str, 'numUpperEn')
        },
        {
          label: '车号', field: 'trainNo', maxlength: 16,
          validate: str => this.validateStr(str, 'onlyNum')
        },
        {
          label: '集装箱号(1)', field: 'containerNo1', maxlength: 16,
          validate: str => this.validateStr(str, 'numUpperEn')
        },
        {
          label: '集装箱号(2)', field: 'containerNo2', maxlength: 16,
          validate: str => this.validateStr(str, 'numUpperEn')
        },
        {
          label: '标重(T)', field: 'trainLoad', maxlength: 5,
          validate: str => this.validateStr(str, 'isIntegerDecimal')
        },
        {
          label: '自重(T)', field: 'trainSelf', maxlength: 5,
          validate: str => this.validateStr(str, 'isIntegerDecimal')
        },
      ],
    }
  },
  created() {
  },
  methods: {
    updateCarriage(info) {
      this.$emit('updateCarriage', info)
    },
  },
  watch: {
    carriageInfo: {
      handler(info) {
        const result = {}
        // 只取后台接口需要的字段
        const keys = ['id', 'trainNo', 'trainType', 'trainLoad', 'trainSelf', 'containerNo1', 'containerNo2']
        keys.forEach((key) => {
          result[key] = info[key]
        })
        this.formData = result
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.carriage-form {
  padding: 3px 0;

  .form-container {
    font-size: 20px;
    margin-top: -3px;
  }
}
</style>
